import script from "./permissionList.vue?vue&type=script&setup=true&lang=js"
export * from "./permissionList.vue?vue&type=script&setup=true&lang=js"

import "./permissionList.vue?vue&type=style&index=0&id=5fe27b34&lang=scss"

const __exports__ = script;

export default __exports__